<template>
    <div class="form-group">
        <label :for="'input_'+block.id" v-text="label"></label>
        <markdown-editor :value="this.block.text" @input="handleInput" ref="input" :id="'input_'+block.id"></markdown-editor>
    </div>
</template>
<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      block: this.value
    };
  },
  methods: {
    save() {
      let form = new FormData();
      if (!this.block.text) {
        return true;
      }
      form.set("edit_long_text_part[translation_text]", this.block.text);
      form.set("edit_long_text_part[submit]", null);
      store.commit("addSavingProcess");
      return axios
        .post(
          "/api/" +
            store.state.language +
            "/content/" +
            this.block.id +
            "/edit_long_text_part",
          form
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
          return data.result;
        });
    },
    handleInput($event) {
      this.block.text = $event;
      this.$emit("input", this.block);
    }
  }
};
</script>
<style>
@import 'simplemde-theme-base/dist/simplemde-theme-base.min.css';
</style>



// WEBPACK FOOTER //
// src/components/Parts/Input/LongText.vue